import React from 'react';
import styled from 'styled-components';
import {Btn} from '../btn/Btn';
import {Icon} from '../icon/Icon';

const Timeline = styled.div`
    padding-top: var(--space);
`;

const TimelineItem = ({icon, status, children}) => {
    return (
        <TimelineContainer>
            <TimelineIcon icon={icon} status={status}>
                <Icon icon={icon} />

                <StatusIcon>
                    {status === 'complete' && <Icon icon="check" />}
                    {status === 'new' && <Icon icon="fiberNew" />}
                    {status === 'delete' && <Icon icon="delete" />}
                    {status === 'change' && <Icon icon="edit" />}
                </StatusIcon>
            </TimelineIcon>

            <TimelineData>{children}</TimelineData>
        </TimelineContainer>
    );
};

const TimelineData = styled.div`
    width: 100%;
`;

const StatusIcon = styled.div`
    --status-circle-height: 11px;
    width: var(--status-circle-height);
    height: var(--status-circle-height);
    border-radius: 50%;
    position: relative;
    left: 22px;
    top: 20px;
    > span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        svg {
            padding-bottom: 3px;
            width: calc(var(--status-circle-height) + 1px);
            height: calc(var(--status-circle-height) + 1px);
            color: white;
        }
    }
`;

const TimelineIcon = styled.div`
    height: var(--timeline-circle-height);
    width: var(--timeline-circle-height);
    border: 1px solid green;
    border-radius: 50%;
    position: relative;
    flex-shrink: 0;
    > span {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        svg {
            padding-bottom: 2px;
            width: calc(var(--timeline-circle-height) - 18px);
            height: calc(var(--timeline-circle-height) - 18px);
        }
    }

    ${({status}) => {
        if (status === 'new' || status === 'complete')
            return `
            background: var(--success-light);
            border-color: var(--success);
            ${StatusIcon} {
                background: var(--success);
            }
            
        `;
        if (status === 'delete')
            return `
            background: var(--danger-light);
            border-color: var(--danger);
            ${StatusIcon} {
                background: var(--danger);
            }
            
        `;
        if (status === 'change')
            return `
                background: var(--primary-light);
                border-color: var(--primary);
                ${StatusIcon} {
                    background: var(--primary);
                }
            `;
        else return '';
    }}
`;

const TimelineContainer = styled.div`
    --timeline-circle-height: 40px;
    display: flex;
    padding-bottom: var(--space-lg);
    justify-content: space-between;
    gap: var(--space-sm);
    position: relative;

    ${Btn} {
        font-size: 12px;
        padding: 0;
    }

    &:not(:last-of-type) {
        &::before {
            content: '';
            width: 1px;
            height: 100%;
            background: #e6e6e6;
            display: block;
            position: absolute;
            top: 0;
            left: calc((var(--timeline-circle-height) / 2) - 0.5px);
        }
    }
`;

export {Timeline, TimelineItem};

Timeline.Item = TimelineItem;
